/* ═══════════════════════════════════════════════════════════════════
   RFW RETOS DE CLUBES — Mock Data
   BLOQUE 27 DE 100 — Retos de Clubes
   ═══════════════════════════════════════════════════════════════════ */

export type RetoPeriodo = 'diario' | 'semanal' | 'mensual' | 'especial' | 'patrocinado';

export const retoPeriodoLabels: Record<RetoPeriodo, string> = {
  diario: 'Reto Diario',
  semanal: 'Reto Semanal',
  mensual: 'Reto Mensual',
  especial: 'Reto Especial',
  patrocinado: 'Reto Patrocinado',
};

export const retoPeriodoIcons: Record<RetoPeriodo, string> = {
  diario: 'ri-sun-line',
  semanal: 'ri-calendar-check-line',
  mensual: 'ri-calendar-2-line',
  especial: 'ri-star-line',
  patrocinado: 'ri-hand-coin-line',
};

export const retoPeriodoColors: Record<RetoPeriodo, { badge: string; dot: string; text: string; bg: string }> = {
  diario: { badge: 'bg-sky-100 border-sky-300', dot: 'bg-sky-400', text: 'text-sky-700', bg: 'bg-sky-500' },
  semanal: { badge: 'bg-emerald-100 border-emerald-300', dot: 'bg-emerald-400', text: 'text-emerald-700', bg: 'bg-emerald-500' },
  mensual: { badge: 'bg-amber-100 border-amber-300', dot: 'bg-amber-400', text: 'text-amber-700', bg: 'bg-amber-500' },
  especial: { badge: 'bg-rose-100 border-rose-300', dot: 'bg-rose-400', text: 'text-rose-700', bg: 'bg-rose-500' },
  patrocinado: { badge: 'bg-violet-100 border-violet-300', dot: 'bg-violet-400', text: 'text-violet-700', bg: 'bg-violet-500' },
};

/* ─── Recompensa de Reto ─── */
export type TipoRecompensa = 'puntos' | 'insignia' | 'vip' | 'premio' | 'entrada';

export interface RetoRecompensa {
  tipo: TipoRecompensa;
  label: string;
  icon: string;
  color: string;
  bg: string;
  valor?: number;
  descripcion: string;
}

export const recompensaConfig: Record<TipoRecompensa, { label: string; icon: string; color: string; bg: string }> = {
  puntos: { label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100' },
  insignia: { label: 'Insignia', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100' },
  vip: { label: 'VIP', icon: 'ri-vip-crown-line', color: 'text-amber-600', bg: 'bg-amber-100' },
  premio: { label: 'Premio', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100' },
  entrada: { label: 'Entrada', icon: 'ri-ticket-line', color: 'text-emerald-600', bg: 'bg-emerald-100' },
};

/* ─── Reto ─── */
export interface RetoClub {
  id: number;
  titulo: string;
  descripcion: string;
  instrucciones: string;
  periodo: RetoPeriodo;
  objetivo: number;
  progresoGlobal: number;
  participantes: number;
  completados: number;
  fechaInicio: string;
  fechaFin: string;
  activo: boolean;
  destacado: boolean;
  popular: boolean;
  clubId: number;
  clubNombre: string;
  clubTipo: string;
  recompensas: RetoRecompensa[];
  scoreBase: number;
  patrocinador?: string;
  patrocinadorLogo?: string;
  categoria: string;
}

/* ─── Mi Progreso ─── */
export interface MiProgresoReto {
  retoId: number;
  posicion: number;
  totalParticipantes: number;
  progreso: number;
  objetivo: number;
  porcentaje: number;
  tiempoRestante: string;
  estado: 'participando' | 'completado' | 'pendiente';
  fechaCompletado?: string;
}

/* ─── Leaderboard Entry ─── */
export interface RetoLeaderboardEntry {
  posicion: number;
  nombre: string;
  avatarUrl: string;
  progreso: number;
  objetivo: number;
  completado: boolean;
  tiempoTotal?: string;
}

/* ═══════════════════════════════════════════════════════════════════
   RETOS — 30 challenges
   ═══════════════════════════════════════════════════════════════════ */

export const retosClub: RetoClub[] = [
  /* ─── DIARIOS (8) ─── */
  {
    id: 1,
    titulo: 'Comentar 5 publicaciones',
    descripcion: 'Dejá tu opinión en 5 publicaciones del club hoy.',
    instrucciones: 'Entrá a las publicaciones del club y dejá un comentario en cada una. Pueden ser posts, fotos o videos.',
    periodo: 'diario',
    objetivo: 5,
    progresoGlobal: 3420,
    participantes: 1280,
    completados: 684,
    fechaInicio: '2026-06-21',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 1,
    clubNombre: 'Nueva Actitud Fans',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 25, descripcion: '+25 pts al completar el reto' },
    ],
    scoreBase: 25,
    categoria: 'Interacción',
  },
  {
    id: 2,
    titulo: 'Escuchar 30 minutos',
    descripcion: 'Conectate a tu radio del club y escuchá al menos 30 minutos hoy.',
    instrucciones: 'Abrí la transmisión en vivo de la radio del club y mantenela activa por 30 minutos. El progreso se registra automáticamente.',
    periodo: 'diario',
    objetivo: 30,
    progresoGlobal: 8560,
    participantes: 2150,
    completados: 1712,
    fechaInicio: '2026-06-21',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 2,
    clubNombre: 'Comunidad Fe y Esperanza',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 20, descripcion: '+20 pts al completar el reto' },
    ],
    scoreBase: 20,
    categoria: 'Escucha',
  },
  {
    id: 3,
    titulo: 'Reaccionar a 3 posts',
    descripcion: 'Reaccioná con emoji a 3 publicaciones del club.',
    instrucciones: 'Navegá por el feed del club y reaccioná a 3 publicaciones. Podés usar cualquier emoji de reacción.',
    periodo: 'diario',
    objetivo: 3,
    progresoGlobal: 5100,
    participantes: 1580,
    completados: 1020,
    fechaInicio: '2026-06-21',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 3,
    clubNombre: 'La Mexicana Fan Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 15, descripcion: '+15 pts al completar el reto' },
    ],
    scoreBase: 15,
    categoria: 'Interacción',
  },
  {
    id: 4,
    titulo: 'Entrar 3 días seguidos',
    descripcion: 'Mantené tu racha visitando el club 3 días consecutivos.',
    instrucciones: 'Visitá el club todos los días. Tu racha se registra automáticamente al entrar al espacio del club.',
    periodo: 'diario',
    objetivo: 3,
    progresoGlobal: 2340,
    participantes: 4200,
    completados: 780,
    fechaInicio: '2026-06-19',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 7,
    clubNombre: 'Deportes Total Fanáticos',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 50, descripcion: '+50 pts de bonus por mantener la racha' },
      { tipo: 'insignia', label: 'Insignia Racha', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Compromiso al completar la racha de 3 días' },
    ],
    scoreBase: 50,
    categoria: 'Fidelidad',
  },
  {
    id: 5,
    titulo: 'Compartir 3 publicaciones',
    descripcion: 'Compartí 3 publicaciones del club en tus redes sociales.',
    instrucciones: 'Usá el botón de compartir en 3 publicaciones distintas del club. Podés compartir en WhatsApp, Facebook, o copiar el enlace.',
    periodo: 'diario',
    objetivo: 3,
    progresoGlobal: 1890,
    participantes: 890,
    completados: 630,
    fechaInicio: '2026-06-21',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 5,
    clubNombre: 'Rock Total Legion',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 30, descripcion: '+30 pts al completar el reto' },
    ],
    scoreBase: 30,
    categoria: 'Difusión',
  },
  {
    id: 6,
    titulo: 'Invitar 2 amigos',
    descripcion: 'Invita a 2 amigos a unirse al club.',
    instrucciones: 'Usá el botón "Invitar Amigos" del club. Compartí el enlace de invitación con 2 personas.',
    periodo: 'diario',
    objetivo: 2,
    progresoGlobal: 1240,
    participantes: 620,
    completados: 620,
    fechaInicio: '2026-06-21',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 12,
    clubNombre: 'Banda MX Army',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 60, descripcion: '+60 pts por cada amigo que se une' },
      { tipo: 'insignia', label: 'Insignia Conector', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Conector al invitar 2 amigos en un día' },
    ],
    scoreBase: 120,
    categoria: 'Crecimiento',
  },
  {
    id: 7,
    titulo: 'Like a 10 publicaciones',
    descripcion: 'Dale like a 10 publicaciones del feed del club.',
    instrucciones: 'Recorré el feed del club y dale like a 10 publicaciones diferentes. No importa el tipo de contenido.',
    periodo: 'diario',
    objetivo: 10,
    progresoGlobal: 6780,
    participantes: 1840,
    completados: 1356,
    fechaInicio: '2026-06-21',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 9,
    clubNombre: 'La Kalle Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 20, descripcion: '+20 pts al completar el reto' },
    ],
    scoreBase: 20,
    categoria: 'Interacción',
  },
  {
    id: 8,
    titulo: 'Participar en Cabina',
    descripcion: 'Entrá a la cabina de tu radio y participá del chat en vivo.',
    instrucciones: 'Entrá a la cabina de la radio del club y escribí al menos un mensaje en el chat durante la transmisión.',
    periodo: 'diario',
    objetivo: 1,
    progresoGlobal: 3150,
    participantes: 1250,
    completados: 1050,
    fechaInicio: '2026-06-21',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: true,
    clubId: 1,
    clubNombre: 'Nueva Actitud Fans',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 35, descripcion: '+35 pts por participar en cabina' },
    ],
    scoreBase: 35,
    categoria: 'Participación',
  },

  /* ─── SEMANALES (8) ─── */
  {
    id: 101,
    titulo: 'Comentar 30 publicaciones',
    descripcion: 'Dejá 30 comentarios en el club durante la semana.',
    instrucciones: 'Comentá en publicaciones todos los días. Llevamos el conteo automático. ¡Son solo 4-5 comentarios por día!',
    periodo: 'semanal',
    objetivo: 30,
    progresoGlobal: 12400,
    participantes: 3420,
    completados: 1750,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 3,
    clubNombre: 'La Mexicana Fan Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 150, descripcion: '+150 pts al completar el reto' },
      { tipo: 'insignia', label: 'Insignia Conversador', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Conversador por 30 comentarios en una semana' },
    ],
    scoreBase: 150,
    categoria: 'Interacción',
  },
  {
    id: 102,
    titulo: 'Escuchar 5 horas totales',
    descripcion: 'Acumulá 5 horas de escucha de tu radio del club esta semana.',
    instrucciones: 'Escuchá la radio del club todos los días un ratito. 45 minutos por día es suficiente para llegar.',
    periodo: 'semanal',
    objetivo: 5,
    progresoGlobal: 18900,
    participantes: 5600,
    completados: 3780,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: true,
    clubId: 2,
    clubNombre: 'Comunidad Fe y Esperanza',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 100, descripcion: '+100 pts por 5 horas de escucha' },
      { tipo: 'entrada', label: 'Entrada Evento', icon: 'ri-ticket-line', color: 'text-emerald-600', bg: 'bg-emerald-100', descripcion: 'Entrada preferencial al próximo evento del club' },
    ],
    scoreBase: 100,
    categoria: 'Escucha',
  },
  {
    id: 103,
    titulo: 'Invitar 5 amigos al club',
    descripcion: 'Traé 5 amigos nuevos al club esta semana.',
    instrucciones: 'Usá el enlace de invitación del club y compartilo con tus amigos. Cada uno que entre suma.',
    periodo: 'semanal',
    objetivo: 5,
    progresoGlobal: 4200,
    participantes: 1680,
    completados: 840,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: true,
    popular: false,
    clubId: 7,
    clubNombre: 'Deportes Total Fanáticos',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 250, descripcion: '+250 pts por 5 amigos invitados' },
      { tipo: 'vip', label: 'VIP Semanal', icon: 'ri-vip-crown-line', color: 'text-amber-600', bg: 'bg-amber-100', descripcion: 'Status VIP por una semana al completar el reto' },
      { tipo: 'insignia', label: 'Insignia Constructor', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Constructor por 5 invitaciones en una semana' },
    ],
    scoreBase: 250,
    categoria: 'Crecimiento',
  },
  {
    id: 104,
    titulo: 'Compartir 12 publicaciones',
    descripcion: 'Compartí 12 publicaciones del club durante la semana.',
    instrucciones: 'Compartí contenido del club en tus redes. Promedio de 2 por día es suficiente.',
    periodo: 'semanal',
    objetivo: 12,
    progresoGlobal: 6700,
    participantes: 2450,
    completados: 1340,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 5,
    clubNombre: 'Rock Total Legion',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 120, descripcion: '+120 pts al completar el reto' },
    ],
    scoreBase: 120,
    categoria: 'Difusión',
  },
  {
    id: 105,
    titulo: 'Participar en 3 encuestas',
    descripcion: 'Votá en 3 encuestas del club esta semana.',
    instrucciones: 'Buscá las encuestas activas en el club y votá en al menos 3.',
    periodo: 'semanal',
    objetivo: 3,
    progresoGlobal: 8900,
    participantes: 3200,
    completados: 2967,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 9,
    clubNombre: 'La Kalle Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 80, descripcion: '+80 pts por participar en 3 encuestas' },
    ],
    scoreBase: 80,
    categoria: 'Participación',
  },
  {
    id: 106,
    titulo: 'Subir 2 fotos al club',
    descripcion: 'Compartí 2 fotos en la sección de fotos del club.',
    instrucciones: 'Entrá a la galería del club y subí 2 fotos relacionadas con la comunidad o la temática del club.',
    periodo: 'semanal',
    objetivo: 2,
    progresoGlobal: 3400,
    participantes: 1700,
    completados: 1700,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 1,
    clubNombre: 'Nueva Actitud Fans',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 90, descripcion: '+90 pts por subir 2 fotos' },
    ],
    scoreBase: 90,
    categoria: 'Contenido',
  },
  {
    id: 107,
    titulo: 'Asistir al evento del club',
    descripcion: 'Confirmá tu asistencia y participá del evento semanal del club.',
    instrucciones: 'Marcá "Asistiré" en el evento del club y participá durante la fecha programada.',
    periodo: 'semanal',
    objetivo: 1,
    progresoGlobal: 1800,
    participantes: 2800,
    completados: 1550,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: true,
    popular: false,
    clubId: 12,
    clubNombre: 'Banda MX Army',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 200, descripcion: '+200 pts por asistir al evento' },
      { tipo: 'premio', label: 'Premio Exclusivo', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Kit de merchandising del club para los que asisten al evento' },
    ],
    scoreBase: 200,
    categoria: 'Eventos',
  },
  {
    id: 108,
    titulo: 'Mantener racha de 7 días',
    descripcion: 'Visitá el club todos los días de la semana sin faltar.',
    instrucciones: 'Entrá al club cada día. Al séptimo día consecutivo completás el reto automáticamente.',
    periodo: 'semanal',
    objetivo: 7,
    progresoGlobal: 15600,
    participantes: 6200,
    completados: 3900,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 3,
    clubNombre: 'La Mexicana Fan Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 200, descripcion: '+200 pts por racha perfecta de 7 días' },
      { tipo: 'insignia', label: 'Insignia Constante', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Constancia: 7 días seguidos en el club' },
      { tipo: 'vip', label: 'VIP Mensual', icon: 'ri-vip-crown-line', color: 'text-amber-600', bg: 'bg-amber-100', descripcion: 'Acceso anticipado a contenido del club por completar la racha semanal' },
    ],
    scoreBase: 200,
    categoria: 'Fidelidad',
  },

  /* ─── MENSUALES (6) ─── */
  {
    id: 201,
    titulo: 'Top Comentador del Mes',
    descripcion: 'Sé el miembro con más comentarios de calidad en el club este mes.',
    instrucciones: 'Participá activamente dejando comentarios en las publicaciones. El top 10 recibe recompensa.',
    periodo: 'mensual',
    objetivo: 50,
    progresoGlobal: 28900,
    participantes: 4800,
    completados: 2400,
    fechaInicio: '2026-06-01',
    fechaFin: '2026-07-01',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 3,
    clubNombre: 'La Mexicana Fan Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 500, descripcion: '+500 pts por ser Top Comentador' },
      { tipo: 'insignia', label: 'Insignia Comentador del Mes', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia exclusiva de Comentador del Mes' },
      { tipo: 'vip', label: 'VIP por 1 mes', icon: 'ri-vip-crown-line', color: 'text-amber-600', bg: 'bg-amber-100', descripcion: 'Status VIP completo por un mes' },
      { tipo: 'premio', label: 'Premio Sorpresa', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Paquete sorpresa del club con merchandising exclusivo' },
    ],
    scoreBase: 500,
    categoria: 'Interacción',
  },
  {
    id: 202,
    titulo: 'Maratón de Escucha',
    descripcion: 'Acumulá 20 horas de escucha durante el mes.',
    instrucciones: 'Escuchá tu radio del club regularmente. Menos de 1 hora por día alcanza.',
    periodo: 'mensual',
    objetivo: 20,
    progresoGlobal: 45200,
    participantes: 7800,
    completados: 3900,
    fechaInicio: '2026-06-01',
    fechaFin: '2026-07-01',
    activo: true,
    destacado: false,
    popular: true,
    clubId: 7,
    clubNombre: 'Deportes Total Fanáticos',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 350, descripcion: '+350 pts por 20 horas de escucha' },
      { tipo: 'insignia', label: 'Insignia Oyente Pro', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia Oyente Pro por completar 20 horas' },
    ],
    scoreBase: 350,
    categoria: 'Escucha',
  },
  {
    id: 203,
    titulo: 'Invitador Estelar',
    descripcion: 'Traé 10 nuevos miembros al club este mes.',
    instrucciones: 'Compartí el enlace de invitación del club. Cada persona que se une usando tu enlace cuenta.',
    periodo: 'mensual',
    objetivo: 10,
    progresoGlobal: 8900,
    participantes: 2400,
    completados: 890,
    fechaInicio: '2026-06-01',
    fechaFin: '2026-07-01',
    activo: true,
    destacado: true,
    popular: false,
    clubId: 12,
    clubNombre: 'Banda MX Army',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 800, descripcion: '+800 pts por 10 invitados nuevos' },
      { tipo: 'insignia', label: 'Insignia Embajador del Club', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Embajador del Club' },
      { tipo: 'vip', label: 'VIP 3 meses', icon: 'ri-vip-crown-line', color: 'text-amber-600', bg: 'bg-amber-100', descripcion: 'Status VIP extendido por 3 meses' },
      { tipo: 'entrada', label: 'Entrada Concierto', icon: 'ri-ticket-line', color: 'text-emerald-600', bg: 'bg-emerald-100', descripcion: '2 entradas para el próximo concierto patrocinado' },
    ],
    scoreBase: 800,
    categoria: 'Crecimiento',
  },
  {
    id: 204,
    titulo: 'Creador de Contenido',
    descripcion: 'Publicá 15 posts originales en el club durante el mes.',
    instrucciones: 'Creá contenido original: posts, fotos, videos. Al menos 15 en el mes para completar el reto.',
    periodo: 'mensual',
    objetivo: 15,
    progresoGlobal: 12400,
    participantes: 3200,
    completados: 1860,
    fechaInicio: '2026-06-01',
    fechaFin: '2026-07-01',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 5,
    clubNombre: 'Rock Total Legion',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 400, descripcion: '+400 pts por 15 publicaciones' },
      { tipo: 'insignia', label: 'Insignia Creador', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Creador de Contenido' },
    ],
    scoreBase: 400,
    categoria: 'Contenido',
  },
  {
    id: 205,
    titulo: 'Participante Integral',
    descripcion: 'Participá en al menos 6 tipos de actividades del club: posts, encuestas, eventos, concursos, retos, cabina.',
    instrucciones: 'Diversificá tu participación. Cada tipo de actividad cuenta una vez.',
    periodo: 'mensual',
    objetivo: 6,
    progresoGlobal: 5600,
    participantes: 2800,
    completados: 933,
    fechaInicio: '2026-06-01',
    fechaFin: '2026-07-01',
    activo: true,
    destacado: true,
    popular: false,
    clubId: 1,
    clubNombre: 'Nueva Actitud Fans',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 600, descripcion: '+600 pts por participar en 6 tipos de actividades' },
      { tipo: 'insignia', label: 'Insignia Integral', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Participante Integral' },
      { tipo: 'premio', label: 'Reconocimiento en Vivo', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Mención especial durante la transmisión en vivo de la radio' },
    ],
    scoreBase: 600,
    categoria: 'Participación',
  },
  {
    id: 206,
    titulo: 'Ganador de Retos',
    descripcion: 'Completá al menos 15 retos del club durante el mes.',
    instrucciones: 'Revisá los retos diarios y semanales del club. Completá al menos 15 en total.',
    periodo: 'mensual',
    objetivo: 15,
    progresoGlobal: 7200,
    participantes: 4200,
    completados: 480,
    fechaInicio: '2026-06-01',
    fechaFin: '2026-07-01',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 3,
    clubNombre: 'La Mexicana Fan Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 1000, descripcion: '+1000 pts por 15 retos completados' },
      { tipo: 'insignia', label: 'Insignia Rey de Retos', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia Rey de los Retos del Mes' },
      { tipo: 'vip', label: 'VIP Premium', icon: 'ri-vip-crown-line', color: 'text-amber-600', bg: 'bg-amber-100', descripcion: 'Upgrade a VIP Premium con todos los beneficios' },
      { tipo: 'premio', label: 'Gran Premio del Mes', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Premio mayor: equipo de audio + merch del club + foto con los locutores' },
    ],
    scoreBase: 1000,
    categoria: 'Retos',
  },

  /* ─── ESPECIALES (4) ─── */
  {
    id: 301,
    titulo: 'Aniversario del Club',
    descripcion: 'Reto especial de aniversario: participá en 10 actividades durante la semana de celebración.',
    instrucciones: 'Durante la semana de aniversario del club, todas las actividades cuentan el doble. Completá 10 para festejar.',
    periodo: 'especial',
    objetivo: 10,
    progresoGlobal: 18500,
    participantes: 5600,
    completados: 3700,
    fechaInicio: '2026-06-14',
    fechaFin: '2026-06-28',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 12,
    clubNombre: 'Banda MX Army',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 500, descripcion: '+500 pts por el reto especial de aniversario' },
      { tipo: 'insignia', label: 'Insignia Aniversario', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia conmemorativa de aniversario del club' },
      { tipo: 'vip', label: 'VIP Aniversario', icon: 'ri-vip-crown-line', color: 'text-amber-600', bg: 'bg-amber-100', descripcion: 'Status VIP especial de aniversario con beneficios extra' },
      { tipo: 'premio', label: 'Sorteo Aniversario', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Participación automática en el sorteo de aniversario' },
      { tipo: 'entrada', label: 'Fiesta de Aniversario', icon: 'ri-ticket-line', color: 'text-emerald-600', bg: 'bg-emerald-100', descripcion: 'Entrada VIP a la fiesta de aniversario del club' },
    ],
    scoreBase: 500,
    categoria: 'Especial',
  },
  {
    id: 302,
    titulo: 'Trivia Especial RFW',
    descripcion: 'Trivia temática especial del club. Responde 20 preguntas sobre la historia del club.',
    instrucciones: 'Participá en la trivia especial. Cada respuesta correcta cuenta. 20 preguntas para ganar.',
    periodo: 'especial',
    objetivo: 20,
    progresoGlobal: 12400,
    participantes: 3400,
    completados: 1700,
    fechaInicio: '2026-06-10',
    fechaFin: '2026-06-30',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 7,
    clubNombre: 'Deportes Total Fanáticos',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 300, descripcion: '+300 pts por completar la trivia especial' },
      { tipo: 'insignia', label: 'Insignia Experto', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Experto en la historia del club' },
    ],
    scoreBase: 300,
    categoria: 'Especial',
  },
  {
    id: 303,
    titulo: 'Torneo Relámpago de Clubes',
    descripcion: 'Tu club vs otros clubes. El que más participación tenga en 48 horas gana.',
    instrucciones: 'Participá en todas las actividades posibles del club durante 48 horas. Cada acción suma puntos para tu club.',
    periodo: 'especial',
    objetivo: 20,
    progresoGlobal: 45200,
    participantes: 8200,
    completados: 3200,
    fechaInicio: '2026-06-20',
    fechaFin: '2026-06-22',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 3,
    clubNombre: 'La Mexicana Fan Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 400, descripcion: '+400 pts por participar en el torneo relámpago' },
      { tipo: 'insignia', label: 'Insignia Gladiador', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Gladiador del Torneo Relámpago' },
    ],
    scoreBase: 400,
    categoria: 'Especial',
  },
  {
    id: 304,
    titulo: 'Playlist Colaborativa Masiva',
    descripcion: 'Cada miembro agrega una canción. Creamos la playlist del club con 500 canciones.',
    instrucciones: 'Agregá tu canción favorita a la playlist colaborativa del club. Al llegar a 500, se transmite al aire.',
    periodo: 'especial',
    objetivo: 1,
    progresoGlobal: 478,
    participantes: 478,
    completados: 478,
    fechaInicio: '2026-06-05',
    fechaFin: '2026-06-30',
    activo: true,
    destacado: false,
    popular: true,
    clubId: 9,
    clubNombre: 'La Kalle Club',
    clubTipo: 'oficial_radio',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 50, descripcion: '+50 pts por agregar tu canción' },
      { tipo: 'insignia', label: 'Insignia Curador', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Curador Musical' },
    ],
    scoreBase: 50,
    categoria: 'Especial',
  },

  /* ─── PATROCINADOS (4) ─── */
  {
    id: 401,
    titulo: 'Trivia Patrocinada: Historia del Rock',
    descripcion: 'Trivia patrocinada por Rock Legends. Responde 15 preguntas sobre historia del rock.',
    instrucciones: 'Entrá a la trivia y respondé las 15 preguntas. Cada acierto suma puntos.',
    periodo: 'patrocinado',
    objetivo: 15,
    progresoGlobal: 8900,
    participantes: 3400,
    completados: 2200,
    fechaInicio: '2026-06-15',
    fechaFin: '2026-06-30',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 304,
    clubNombre: 'Rock Legends Vault',
    clubTipo: 'premium',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 250, descripcion: '+250 pts por completar la trivia' },
      { tipo: 'premio', label: 'Vinilo Firmado', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Vinilo de colección firmado - auspiciado por Rock Legends' },
      { tipo: 'entrada', label: 'Entrada Concierto', icon: 'ri-ticket-line', color: 'text-emerald-600', bg: 'bg-emerald-100', descripcion: '2 entradas VIP para el próximo concierto' },
    ],
    scoreBase: 250,
    patrocinador: 'Rock Legends Store',
    patrocinadorLogo: 'https://readdy.ai/api/search-image?query=Music%20store%20brand%20logo%20with%20guitar%20and%20vinyl%20record%20emblem%2C%20circular%20design%20dark%20red%20and%20gold%20colors%2C%20classic%20rock%20aesthetic%2C%20clean%20modern%20brand%20mark%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=sponsor-rocklegends&orientation=squarish',
    categoria: 'Patrocinado',
  },
  {
    id: 402,
    titulo: 'Concurso de Fotos Deportivas',
    descripcion: 'Subí tu mejor foto deportiva. La más votada gana. Patrocinado por Deporte Total.',
    instrucciones: 'Subí una foto relacionada con deportes a la galería del club. La comunidad vota.',
    periodo: 'patrocinado',
    objetivo: 1,
    progresoGlobal: 2340,
    participantes: 2340,
    completados: 1650,
    fechaInicio: '2026-06-10',
    fechaFin: '2026-06-28',
    activo: true,
    destacado: false,
    popular: true,
    clubId: 302,
    clubNombre: 'Deportivo Premium',
    clubTipo: 'premium',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 150, descripcion: '+150 pts por participar' },
      { tipo: 'premio', label: 'Camiseta Oficial', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Camiseta oficial firmada por el equipo' },
      { tipo: 'insignia', label: 'Insignia Fotógrafo', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia de Fotógrafo Deportivo' },
    ],
    scoreBase: 150,
    patrocinador: 'Deporte Total',
    patrocinadorLogo: 'https://readdy.ai/api/search-image?query=Sports%20brand%20logo%20with%20dynamic%20action%20lines%20and%20star%20emblem%2C%20circular%20design%20navy%20and%20orange%20colors%2C%20modern%20athletic%20aesthetic%2C%20clean%20brand%20mark%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=sponsor-deporte&orientation=squarish',
    categoria: 'Patrocinado',
  },
  {
    id: 403,
    titulo: 'Escuchá y Ganá',
    descripcion: 'Acumulá 10 horas de escucha en radio Éxito FM. Patrocinado por AudioPro.',
    instrucciones: 'Escuchá Radio Éxito FM desde la app o web. Cada hora suma. Al llegar a 10 horas participás del sorteo.',
    periodo: 'patrocinado',
    objetivo: 10,
    progresoGlobal: 15600,
    participantes: 4500,
    completados: 3200,
    fechaInicio: '2026-06-01',
    fechaFin: '2026-07-01',
    activo: true,
    destacado: true,
    popular: true,
    clubId: 301,
    clubNombre: 'Élite Select',
    clubTipo: 'premium',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 200, descripcion: '+200 pts por completar 10 horas' },
      { tipo: 'premio', label: 'Auriculares Pro', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Auriculares profesionales AudioPro - auspiciado por AudioPro' },
      { tipo: 'insignia', label: 'Insignia AudioPro', icon: 'ri-award-line', color: 'text-violet-600', bg: 'bg-violet-100', descripcion: 'Insignia especial de la campaña AudioPro' },
    ],
    scoreBase: 200,
    patrocinador: 'AudioPro',
    patrocinadorLogo: 'https://readdy.ai/api/search-image?query=Audio%20equipment%20brand%20logo%20with%20sound%20wave%20and%20headphones%20emblem%2C%20circular%20design%20silver%20and%20black%20colors%2C%20premium%20audio%20aesthetic%2C%20clean%20modern%20brand%20mark%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=sponsor-audiopro&orientation=squarish',
    categoria: 'Patrocinado',
  },
  {
    id: 404,
    titulo: 'Crea tu Remix',
    descripcion: 'Creá un remix usando samples del club y participá. Patrocinado por BeatLab.',
    instrucciones: 'Descargá el pack de samples del club, creá tu remix y subilo. El mejor gana.',
    periodo: 'patrocinado',
    objetivo: 1,
    progresoGlobal: 1240,
    participantes: 1240,
    completados: 580,
    fechaInicio: '2026-06-05',
    fechaFin: '2026-06-30',
    activo: true,
    destacado: false,
    popular: false,
    clubId: 305,
    clubNombre: 'Creadores Premium',
    clubTipo: 'premium',
    recompensas: [
      { tipo: 'puntos', label: 'Puntos RFW', icon: 'ri-flashlight-line', color: 'text-accent-600', bg: 'bg-accent-100', valor: 300, descripcion: '+300 pts por participar' },
      { tipo: 'premio', label: 'Equipo de Producción', icon: 'ri-gift-line', color: 'text-rose-600', bg: 'bg-rose-100', descripcion: 'Kit de producción BeatLab para el ganador' },
      { tipo: 'entrada', label: 'Masterclass', icon: 'ri-ticket-line', color: 'text-emerald-600', bg: 'bg-emerald-100', descripcion: 'Entrada a masterclass exclusiva de producción musical' },
    ],
    scoreBase: 300,
    patrocinador: 'BeatLab',
    patrocinadorLogo: 'https://readdy.ai/api/search-image?query=Music%20production%20brand%20logo%20with%20beat%20waveform%20and%20lab%20beaker%20emblem%2C%20circular%20design%20purple%20and%20cyan%20neon%20colors%2C%20modern%20electronic%20music%20aesthetic%2C%20clean%20futuristic%20brand%20mark%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=sponsor-beatlab&orientation=squarish',
    categoria: 'Patrocinado',
  },
];

/* ═══════════════════════════════════════════════════════════════════
   MI PROGRESO — Simulación de progreso del usuario actual
   ═══════════════════════════════════════════════════════════════════ */

export const miProgresoRetos: MiProgresoReto[] = [
  { retoId: 1, posicion: 342, totalParticipantes: 1280, progreso: 3, objetivo: 5, porcentaje: 60, tiempoRestante: '12h 34m', estado: 'participando' },
  { retoId: 3, posicion: 890, totalParticipantes: 1580, progreso: 3, objetivo: 3, porcentaje: 100, tiempoRestante: 'Completado', estado: 'completado', fechaCompletado: '2026-06-21' },
  { retoId: 4, posicion: 156, totalParticipantes: 4200, progreso: 2, objetivo: 3, porcentaje: 67, tiempoRestante: '1 día', estado: 'participando' },
  { retoId: 8, posicion: 520, totalParticipantes: 1250, progreso: 1, objetivo: 1, porcentaje: 100, tiempoRestante: 'Completado', estado: 'completado', fechaCompletado: '2026-06-21' },
  { retoId: 101, posicion: 687, totalParticipantes: 3420, progreso: 18, objetivo: 30, porcentaje: 60, tiempoRestante: '1 día', estado: 'participando' },
  { retoId: 108, posicion: 1205, totalParticipantes: 6200, progreso: 5, objetivo: 7, porcentaje: 71, tiempoRestante: '2 días', estado: 'participando' },
  { retoId: 201, posicion: 145, totalParticipantes: 4800, progreso: 42, objetivo: 50, porcentaje: 84, tiempoRestante: '10 días', estado: 'participando' },
  { retoId: 206, posicion: 78, totalParticipantes: 4200, progreso: 11, objetivo: 15, porcentaje: 73, tiempoRestante: '10 días', estado: 'participando' },
  { retoId: 302, posicion: 245, totalParticipantes: 3400, progreso: 20, objetivo: 20, porcentaje: 100, tiempoRestante: 'Completado', estado: 'completado', fechaCompletado: '2026-06-18' },
  { retoId: 403, posicion: 1230, totalParticipantes: 4500, progreso: 7, objetivo: 10, porcentaje: 70, tiempoRestante: '10 días', estado: 'participando' },
];

/* ═══════════════════════════════════════════════════════════════════
   LEADERBOARD — Top retadores
   ═══════════════════════════════════════════════════════════════════ */

export const retoLeaderboard: RetoLeaderboardEntry[] = [
  { posicion: 1, nombre: 'Isabella Torres', avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20latina%20woman%20in%20radio%20studio%2C%20warm%20smile%2C%20casual%20elegant%2C%20soft%20studio%20lighting%2C%20friendly%20approachable%20expression%2C%20clean%20portrait%20photography%2C%20neutral%20warm%20background&width=200&height=200&seq=lb-isa&orientation=squarish', progreso: 50, objetivo: 50, completado: true, tiempoTotal: '6d 4h' },
  { posicion: 2, nombre: 'Felipe Gutiérrez', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20latino%20man%20in%20his%20twenties%2C%20charismatic%20smile%2C%20casual%20urban%20style%2C%20clean%20portrait%2C%20editorial%20photography%20with%20soft%20warm%20neutral%20background&width=200&height=200&seq=lb-felipe&orientation=squarish', progreso: 50, objetivo: 50, completado: true, tiempoTotal: '7d 2h' },
  { posicion: 3, nombre: 'Adriana Mejía', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20latina%20woman%20in%20her%20twenties%2C%20warm%20genuine%20smile%2C%20elegant%20casual%20style%2C%20clean%20portrait%2C%20editorial%20photography%20with%20soft%20warm%20neutral%20background&width=200&height=200&seq=lb-adriana&orientation=squarish', progreso: 50, objetivo: 50, completado: true, tiempoTotal: '7d 18h' },
  { posicion: 4, nombre: 'Javier Mendoza', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20latino%20man%20in%20his%20twenties%2C%20sporty%20energetic%20look%2C%20friendly%20smile%2C%20clean%20portrait%2C%20editorial%20photography%20with%20soft%20warm%20neutral%20background&width=200&height=200&seq=lb-javier&orientation=squarish', progreso: 48, objetivo: 50, completado: false },
  { posicion: 5, nombre: 'Camila Restrepo', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20latina%20woman%20in%20her%20twenties%2C%20bright%20cheerful%20smile%2C%20trendy%20casual%20look%2C%20clean%20portrait%2C%20editorial%20photography%20with%20soft%20warm%20neutral%20background&width=200&height=200&seq=lb-camila&orientation=squarish', progreso: 45, objetivo: 50, completado: false },
  { posicion: 6, nombre: 'Carlos "El Capi" Ruiz', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20energetic%20latino%20sports%20commentator%20in%20his%2030s%2C%20passionate%20expression%2C%20casual%20sporty%20look%2C%20dynamic%20studio%20lighting%2C%20enthusiastic%20vibe%2C%20clean%20headshot%20photography%2C%20neutral%20dark%20background&width=200&height=200&seq=lb-carlos&orientation=squarish', progreso: 44, objetivo: 50, completado: false },
  { posicion: 7, nombre: 'Valentina Ríos', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20smiling%20young%20latina%20woman%2C%20natural%20beauty%2C%20casual%20elegant%20look%2C%20soft%20diffused%20studio%20light%2C%20genuine%20expression%2C%20clean%20modern%20headshot%2C%20neutral%20warm%20gray%20background&width=200&height=200&seq=lb-vale&orientation=squarish', progreso: 42, objetivo: 50, completado: false },
  { posicion: 8, nombre: 'Mateo Vega', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20latino%20man%20in%20his%20late%2020s%2C%20casual%20modern%20look%2C%20friendly%20smile%2C%20clean%20studio%20lighting%2C%20approachable%20vibe%2C%20headshot%20photography%2C%20neutral%20cream%20background&width=200&height=200&seq=lb-mateo&orientation=squarish', progreso: 40, objetivo: 50, completado: false },
  { posicion: 9, nombre: 'Sofía Quintero', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20latina%20woman%20in%20her%20twenties%2C%20warm%20genuine%20smile%2C%20casual%20boho%20style%2C%20clean%20portrait%2C%20editorial%20photography%20with%20soft%20warm%20neutral%20background&width=200&height=200&seq=lb-sofia&orientation=squarish', progreso: 38, objetivo: 50, completado: false },
  { posicion: 10, nombre: 'Daniel Ortega', avatarUrl: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20latino%20man%20in%20his%20twenties%2C%20relaxed%20smile%2C%20casual%20t-shirt%2C%20clean%20portrait%2C%20editorial%20photography%20with%20soft%20warm%20neutral%20background&width=200&height=200&seq=lb-daniel&orientation=squarish', progreso: 35, objetivo: 50, completado: false },
];

/* ═══════════════════════════════════════════════════════════════════
   DASHBOARD STATS
   ═══════════════════════════════════════════════════════════════════ */

export const retosDashboard = {
  totalRetos: 30,
  activosAhora: 12,
  diarios: 8,
  semanales: 8,
  mensuales: 6,
  especiales: 4,
  patrocinados: 4,
  participantesTotales: 89200,
  retosCompletados: 42800,
  scoreGenerado: 12450000,
  clubesParticipando: 14,
  patrocinadoresActivos: 4,
};

/* ═══════════════════════════════════════════════════════════════════
   SCORE ACTIONS — Cómo se suma Score con los retos
   ═══════════════════════════════════════════════════════════════════ */

export interface RetoScoreAction {
  key: string;
  label: string;
  icon: string;
  puntos: number;
  desc: string;
  color: string;
  bg: string;
}

export const retoScoreActions: RetoScoreAction[] = [
  { key: 'completar_diario', label: 'Completar Reto Diario', icon: 'ri-sun-line', puntos: 25, desc: '+25 pts por cada reto diario completado', color: 'text-sky-600', bg: 'bg-sky-100' },
  { key: 'completar_semanal', label: 'Completar Reto Semanal', icon: 'ri-calendar-check-line', puntos: 150, desc: '+150 pts por cada reto semanal completado', color: 'text-emerald-600', bg: 'bg-emerald-100' },
  { key: 'completar_mensual', label: 'Completar Reto Mensual', icon: 'ri-calendar-2-line', puntos: 500, desc: '+500 pts por cada reto mensual completado', color: 'text-amber-600', bg: 'bg-amber-100' },
  { key: 'completar_especial', label: 'Completar Reto Especial', icon: 'ri-star-line', puntos: 350, desc: '+350 pts por cada reto especial completado', color: 'text-rose-600', bg: 'bg-rose-100' },
  { key: 'completar_patrocinado', label: 'Completar Reto Patrocinado', icon: 'ri-hand-coin-line', puntos: 250, desc: '+250 pts por cada reto patrocinado completado', color: 'text-violet-600', bg: 'bg-violet-100' },
  { key: 'top_leaderboard', label: 'Entrar al Top 10', icon: 'ri-medal-line', puntos: 300, desc: '+300 pts bonus por entrar al Top 10 del leaderboard', color: 'text-orange-600', bg: 'bg-orange-100' },
  { key: 'racha_retos', label: 'Racha de Retos', icon: 'ri-fire-line', puntos: 100, desc: '+100 pts bonus por completar retos 7 días seguidos', color: 'text-red-600', bg: 'bg-red-100' },
];

/* ═══════════════════════════════════════════════════════════════════
   HELPERS
   ═══════════════════════════════════════════════════════════════════ */

export function getAllRetos(): RetoClub[] {
  return retosClub;
}

export function getRetosActivos(): RetoClub[] {
  return retosClub.filter(r => r.activo);
}

export function getRetosPopulares(): RetoClub[] {
  return retosClub.filter(r => r.popular);
}

export function getRetosDestacados(): RetoClub[] {
  return retosClub.filter(r => r.destacado);
}

export function getRetosByPeriodo(periodo: RetoPeriodo): RetoClub[] {
  return retosClub.filter(r => r.periodo === periodo);
}

export function getRetosByClub(clubId: number): RetoClub[] {
  return retosClub.filter(r => r.clubId === clubId);
}

export function getRetoById(id: number): RetoClub | undefined {
  return retosClub.find(r => r.id === id);
}

export function getMiProgresoByRetoId(retoId: number): MiProgresoReto | undefined {
  return miProgresoRetos.find(p => p.retoId === retoId);
}

export function getMisRetosActivos(): MiProgresoReto[] {
  return miProgresoRetos.filter(p => p.estado === 'participando');
}

export function getMisRetosCompletados(): MiProgresoReto[] {
  return miProgresoRetos.filter(p => p.estado === 'completado');
}

export function formatTiempoRestante(fechaFin: string): string {
  const fin = new Date(fechaFin);
  const ahora = new Date();
  const diff = fin.getTime() - ahora.getTime();
  if (diff <= 0) return 'Finalizado';
  const dias = Math.floor(diff / (1000 * 60 * 60 * 24));
  const horas = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  if (dias > 0) return `${dias}d ${horas}h`;
  const minutos = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  return `${horas}h ${minutos}m`;
}

export function formatRetoCount(n: number): string {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toString();
}